import Vue from "vue";
import Router from "../router";
import { i18n } from "vue-lang-router";

export default class OrderOptions extends Vue {

  static getOrderOptions = {
    itemPerPage: [10, 20, 30],
    sortAttributes: [
      { id: "paymentDate.desc", value: i18n.t("More recent") },
      { id: "paymentDate.asc", value: i18n.t("Less recent") },
      { id: "reference.asc", value: i18n.t("Order reference") },
      { id: "orderState.asc", value: i18n.t("Order state") },
    ],
  };

  static changeItemsPerPage(itemsPerPage: string): void {
    const { query } = Router.history.current;
    delete query.page;
    Router.push({ query: { ...query, itemsPerPage } }).catch();
  }

  static changeSorting(sort: string): void {
    const { query } = Router.history.current;
    Router.push({ query: { ...query, sort } }).catch();
  }

}